module.exports = {"unspecified":"","horde":"","alliance":""};